
import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { getPublicVacancies } from '../../services/VacanciesService';
import { useLanguage } from '../../i18n/LanguageContext';

// Calcula el tiempo transcurrido desde una fecha en formato legible, internacionalizado
function getTimeAgo(dateString, t) {
	if (!dateString) return t('jobsection.publishedAgo') + ' N/A';
	const now = new Date();
	const published = new Date(dateString);
	const diffMs = now - published;
	const diffSec = Math.floor(diffMs / 1000);
	const diffMin = Math.floor(diffSec / 60);
	const diffHour = Math.floor(diffMin / 60);
	const diffDay = Math.floor(diffHour / 24);
	if (diffDay > 0) return `${t('jobsection.publishedAgo')} ${diffDay} ${t('jobsection.day')}${diffDay > 1 ? 's' : ''}`;
	if (diffHour > 0) return `${t('jobsection.publishedAgo')} ${diffHour} ${t('jobsection.hour')}${diffHour > 1 ? 's' : ''}`;
	if (diffMin > 0) return `${t('jobsection.publishedAgo')} ${diffMin} ${t('jobsection.minute')}${diffMin > 1 ? 's' : ''}`;
	return `${t('jobsection.publishedAgo')} ${diffSec} ${t('jobsection.second')}${diffSec > 1 ? 's' : ''}`;
}

export function Jobsection() {
	const [vacancies, setVacancies] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const { t } = useLanguage();

	useEffect(() => {
		setLoading(true);
		getPublicVacancies({ limit: 5, orderBy: 'createdAt', orderDirection: 'desc' })
			.then(res => {
				setVacancies(res.data?.data || []);
				setLoading(false);
			})
			.catch(err => {
				setError(t('jobsection.errorLoadingVacancies'));
				setLoading(false);
			});
	}, [t]);

	return (
		<div className="section-full  content-inner-2">
			<div className="container">
				<div className="d-flex job-title-bx section-head">
					<div className="mr-auto">
						<h2 className="m-b5">{t('jobsection.recentVacancies')}</h2>
						{/* <h6 className="fw4 m-b0">+20 nuevas vacantes</h6> */}
					</div>
					<div className="align-self-end">
						<Link to={"/browse-job-filter-grid"} className="site-button " style={{ backgroundColor: "#009247" }}>{t('jobsection.browseAllVacancies')} <i className="fa fa-long-arrow-right"></i></Link>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-9">
						<ul className="post-job-bx browse-job">
							{loading && <li>{t('jobsection.loadingVacancies')}</li>}
							{error && <li>{error}</li>}
							{!loading && !error && vacancies.length === 0 && <li>{t('jobsection.noVacancies')}</li>}
							{!loading && !error && vacancies.map((item, index) => (
								<li key={item.id || index}>
									<div className="post-bx" >
										<div className="d-flex m-b30">
											<div className="job-post-company">
												<span>
													<img alt="" src={item.imagenEmpresa || require("./../../images/logo/icon1.png")}/>
												</span>
											</div>
											<div className="job-post-info">
												<h4>
												<Link to={`/job-detail/${item.id}`}>{item.titulo || t('jobsection.noTitle')}</Link>
												</h4>
												<ul>
													<li><i className="fa fa-map-marker"></i> {item.ciudadNombre || t('jobsection.noCity')}, {item.paisNombre || t('jobsection.noCountry')}</li>
													<li><i className="fa fa-bookmark-o"></i> {item.tipoContratoTrabajoNombre || t('jobsection.noContractType')}</li>
													<li><i className="fa fa-clock-o"></i> {
														item.tiempoDesdePublicacion
															? `${t('jobsection.publishedAgo')} ${item.tiempoDesdePublicacion}`
															: (item.fechaAprobacion
																? getTimeAgo(item.fechaAprobacion, t)
																: `${t('jobsection.publishedAgo')} N/A`)
													}</li>
												</ul>
											</div>
										</div>
										<div className="d-flex">
											<div className="job-time mr-auto">
												<Link to="#"><span>{item.tipoTrabajo?.nombre || t('jobsection.noJobType')}</span></Link>
											</div>
											<div className="salary-bx">
												<span>{item.salarioTexto || t('jobsection.noSalary')}</span>
											</div>
										</div>

										<label className="like-btn">
											<input type="checkbox" />
											<span className="checkmark"></span>
										</label>
									</div>
								</li>
							))}
						</ul>
                    
					</div>
					{/* <div className="col-lg-3">
						<div className="sticky-top">

							<div className="quote-bx">
								<div className="quote-info">
									<h4>¡Haz la Diferencia con tu Currículum en Línea!</h4>
									<p>Tu currículum en minutos con el asistente de UNIEMPLEO está listo!</p>
									<Link to={"/register"} className="site-button" style={{ backgroundColor: "#009247" }}>Crear una Cuenta</Link>
								</div>
							</div>
						</div>
					</div> */}
				</div>
			</div>
		</div>
	)
}